(function () {
  'use strict';

  // ───── Fade-up on scroll for product page sections ─────
  function initFadeUp() {
    if (!('IntersectionObserver' in window)) return;
    // Shopify prefixes section IDs in JSON templates as
    //   shopify-section-template--{themeSectionId}__{key}
    // so we match by the section key suffix instead of exact id.
    var keys = [
      'trust_strip',
      'emotional_paragraph',
      'customer_testimonials',
      'you_may_also_like',
      'guarantee_cta'
    ];
    var targets = [];
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (el) {
      var id = el.id;
      for (var i = 0; i < keys.length; i++) {
        if (id.indexOf(keys[i]) > -1) {
          targets.push(el);
          break;
        }
      }
    });
    if (!targets.length) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.08, rootMargin: '0px 0px -40px 0px' }
    );

    // Initial hidden state is set via CSS (ID-based selectors in base.css),
    // so it's active before JS runs. JS only adds .is-visible to reveal.
    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFadeUp);
  } else {
    initFadeUp();
  }
})();
